// eslint-disable-next-line ember/no-mixins
import InViewportMixin from 'ember-in-viewport/mixins/in-viewport';

export default InViewportMixin;
